<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>

    <ion-content>
      <LaunchSponsor class="sponsor"></LaunchSponsor>
      <LaunchDonate class="donate"></LaunchDonate>
      <LaunchCooperate class="cooperate" display="inherit"></LaunchCooperate>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import LaunchSponsor from "../components/launch/LaunchSponsor";
import LaunchDonate from "../components/launch/LaunchDonate";
import LaunchCooperate from "../components/launch/LaunchCooperate";
import router from "../router";

export default {
  name: "Credit",
  components: {
    LaunchCooperate,
    LaunchDonate,
    LaunchSponsor,
    WhiteBackground,
    Background,
    IonPage,
    IonContent
  },
  mounted() {
    setTimeout(function () {
      router.replace('/home')
    }, 5000)
  }
}
</script>

<style scoped>
  .sponsor{
    height: 10vh;
    margin-top: 16vh;
  }
  .donate{
    height: 10vh;
    margin-top: 12vh;
  }
  .cooperate{
    height: 10vh;
    margin-top: 12vh;
  }
</style>
